import { render } from "./DialerModal.vue?vue&type=template&id=c530fa86&scoped=true"
import script from "./DialerModal.vue?vue&type=script&lang=js"
export * from "./DialerModal.vue?vue&type=script&lang=js"

import "./DialerModal.vue?vue&type=style&index=0&id=c530fa86&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c530fa86"]])

export default __exports__